/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pc_Dl_File_Win_Arm_Msi_DescInputs */

const en_pc_dl_file_win_arm_msi_desc = /** @type {(inputs: Pc_Dl_File_Win_Arm_Msi_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Windows 11 on ARM laptops.`)
};

const zh_pc_dl_file_win_arm_msi_desc = /** @type {(inputs: Pc_Dl_File_Win_Arm_Msi_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`适用于 ARM 架构的 Windows 11 笔记本。`)
};

/**
* | output |
* | --- |
* | "Windows 11 on ARM laptops." |
*
* @param {Pc_Dl_File_Win_Arm_Msi_DescInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const pc_dl_file_win_arm_msi_desc = /** @type {((inputs?: Pc_Dl_File_Win_Arm_Msi_DescInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pc_Dl_File_Win_Arm_Msi_DescInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pc_dl_file_win_arm_msi_desc(inputs)
	return zh_pc_dl_file_win_arm_msi_desc(inputs)
});
export { pc_dl_file_win_arm_msi_desc as "pc.dl.file.win_arm_msi.desc" }